// TraceManager: lifecycle einer Trace-ID pro Browser-Session.
// Eine ID per Tab/sessionStorage, neu generiert nur wenn nicht da.

const TRACE_ID_KEY = "pfs_trace_id";

class TraceManager {
  generate(): string {
    const id = (typeof crypto !== "undefined" && "randomUUID" in crypto)
      ? crypto.randomUUID()
      : fallbackUuid();
    sessionStorage.setItem(TRACE_ID_KEY, id);
    return id;
  }

  getTraceId(): string {
    let id = sessionStorage.getItem(TRACE_ID_KEY);
    if (!id) id = this.generate();
    return id;
  }

  clear(): void {
    sessionStorage.removeItem(TRACE_ID_KEY);
  }
}

function fallbackUuid(): string {
  // Legacy-Fallback fuer Umgebungen ohne crypto.randomUUID.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const traceManager = new TraceManager();
